export enum USER_ROLE {
	ADMIN = "admin",
	EMPLOYEE = "employee",
	USER = "user",
}
